import { ErrorModel } from "./errorModel";

export class PresupuestoModel {

    anio: number;// 2021,
    clienteDistribuidor: string;// "100002001",
    contenedor: string;// "F55",
    descripcion: string;// "ONPCK POLAR SANDIA 3x2             ",
    item: string;// "5061207",
    mes: number;// 8,
    numeroSemana: number;// 5,
    presupuestoCaja: string;// 15.5,
    presupuestoImporte: string;// 500.71,
    presupuestoKilo: string;// 36.15
    correct: boolean;
    error?: ErrorModel;
    
    constructor() { }

    devolverModeloGridPresupuesto() {
        const objeto: PresupuestoModelInterface = {
            anio: 'anio',
            clienteDistribuidor: 'clienteDistribuidor',
            contenedor: 'contenedor',
            descripcion: 'descripcion',
            item: 'item',
            mes: 'mes',
            numeroSemana: 'numeroSemana',
            presupuestoCaja: 'presupuestoCaja',
            presupuestoImporte: 'presupuestoImporte',
            presupuestoKilo: 'presupuestoKilo',
            correct: 'isCorrect',
            idVendedorDistribuidor: 'idVendedorDistribuidor'
        };
        return objeto;
    }
}
export interface PresupuestoModelInterface {
    anio: string;
    clienteDistribuidor: string;
    contenedor: string;
    descripcion: string;
    item: string;
    mes: string;
    numeroSemana: string;
    presupuestoCaja: string;
    presupuestoImporte: string;
    presupuestoKilo: string;
    correct: string;
    idVendedorDistribuidor: string;
}